import { render } from "./inventoryList.vue?vue&type=template&id=7ff32a84&scoped=true"
import script from "./inventoryList.vue?vue&type=script&lang=js"
export * from "./inventoryList.vue?vue&type=script&lang=js"

import "./inventoryList.vue?vue&type=style&index=0&id=7ff32a84&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7ff32a84"

export default script